import { getChangelogCategoryCode, getChangelogCategoryColor } from "../functions";

function formatChangelogs(logsData) {

  return logsData.changelogs.map(log => {
    return ({
      id: log.id,
      title: log.title,
      code: getChangelogCategoryCode(log.categories[0]),
      color: getChangelogCategoryColor(log.categories[0]),
      description: log.content.short.replace(/"/g, ''),
      seen: logsData.state.seen.includes(log.id),
      read: logsData.state.read.includes(log.id),
      dateTime: log.dateTime,
      url: log.url
    })
  })

}

export const formatResponses = {
  changelogs: (logsData) => formatChangelogs(logsData),
};
